import Vue from 'vue';
import Router from 'vue-router';
import * as _ from 'lodash';

import TokenInfo from '@/views/tokeninfo';
import RTPSDashboard from '@/views/RTPSDashboard';
import PADashboard from '@/views/PADashboard';
import RTPSMetrics from '@/views/RTPSMetrics';
import RTPSPortal from '@/views/RTPSPortal';
import PAPortal from '@/views/PAPortal';
import DataOverride from '@/views/DataOverride';
import OfferList from '@/views/OfferList';
import OfferItem from '@/views/OfferItem';
import CopayEPASourceList from '@/views/CopayEPASourceList';
import CopayEPASourceItem from '@/views/CopayEPASourceItem';
import PrescriberCrosswalk from '@/views/PrescriberCrosswalk';
import DenialCodeMap from '@/views/DenialCodeMap';
import UnmappedDenialCodeMap from '@/views/UnmappedDenialCodeMap';
import BrandLimitList from '@/views/BrandLimitList';
import BrandLimitItem from '@/views/BrandLimitItem';
import Callback from '@/views/Callback';
import ErrorMsg from '@/views/ErrorMsg';
import HealthCheck from '@/views/HealthCheck';
import store from '../store';
import auth from '../services/auth';

Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/callback',
      name: 'callback',
      component: Callback,
      meta: {
        title: 'Authenticating...',
        auth: false
      }
    },
    {
      path: '/error',
      name: 'error',
      component: ErrorMsg,
      props: true,
      meta: {
        title: 'Error',
        auth: false
      }
    },
    {
      path: '',
      name: 'rtps',
      component: {
        render(c) {
          return c("router-view");
        }
      },
      meta: {
        title: 'RTPS',
        auth: true,
        groups: ['RTPSDataViewer'],
        icon: "fa fa-heartbeat",
        isMenuItem: true,
        breadCrumbs: [{
          text: 'RTPS',
          active: true
        }]
      },
      children: [
        {
          path: '/rtps/dashboard',
          name: 'rtps-dashboard',
          component: RTPSDashboard,
          props: true,
          meta: {
            title: 'RTPS Dashboard',
            auth: true,
            groups: ['RTPSDataViewer'],
            icon: "fa fa-tachometer",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'RTPS Dashboard',
              active: true
            }]
          }
        },
        {
          path: '/rtps/portal',
          name: 'rtps-portal',
          component: RTPSPortal,
          props: true,
          meta: {
            title: 'RTPS Portal',
            auth: true,
            groups: ['RTPSDataViewer'],
            icon: "fa fa-file-text-o",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'RTPS Portal',
              active: true
            }]
          }
        },
        {
          path: '/rtps/metrics',
          name: 'rtps-metrics',
          component: RTPSMetrics,
          props: true,
          meta: {
            title: 'RTPS Metrics',
            auth: true,
            groups: ['RTPSDataViewer'],
            icon: "fa fa-line-chart",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'RTPS Metrics',
              active: true
            }]
          }
        },
        {
          path: '/offer',
          name: 'offer-list',
          component: OfferList,
          meta: {
            title: 'RTPS Offers',
            auth: true,
            groups: ['RTPSDataApprover', 'RTPSDataAdmin'],
            icon: "fa fa-ticket",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'RTPS Offers',
              active: true
            }]
          }
        },
        {
          path: '/brand-limit',
          name: 'brand-limit-list',
          component: BrandLimitList,
          meta: {
            title: 'RTPS Brand Limit',
            auth: true,
            groups: ['RTPSDataApprover', 'RTPSDataAdmin'],
            icon: "fa fa-map-o",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'RTPS Brand Limit',
              active: true
            }]
          }
        },
        {
          path: '/healthcheck',
          name: 'healthcheck',
          component: HealthCheck,
          meta: {
            title: 'RTPS Status',
            auth: true,
            groups: ['RTPSDataApprover', 'RTPSDataAdmin'],
            icon: "fa fa-info-circle",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'RTPS Status',
              active: true
            }]
          }
        }
      ]
    },
    {
      path: '',
      name: 'pa',
      component: {
        render(c) {
          return c("router-view");
        }
      },
      meta: {
        title: 'Copay ePA',
        auth: true,
        groups: ['RxChangeDataViewer'],
        icon: "fa fa-credit-card-alt",
        isMenuItem: true,
        breadCrumbs: [{
          text: 'Copay ePA Dashboard',
          active: true
        }]
      },
      children: [
        {
          path: '/pa/dashboard',
          name: 'pa-dashboard',
          component: PADashboard,
          meta: {
            title: 'Copay ePA Dashboard',
            auth: true,
            groups: ['RxChangeDataViewer'],
            icon: "fa fa-tachometer",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'Copay ePA Dashboard',
              active: true
            }]
          }
        },
        {
          path: '/pa/portal',
          name: 'pa-portal',
          component: PAPortal,
          meta: {
            title: 'Copay ePA Portal',
            auth: true,
            groups: ['RxChangeDataViewer'],
            icon: "fa fa-file-text-o",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'Copay ePA Portal',
              active: true
            }]
          }
        },
        {
          path: '/data-override',
          name: 'data-override',
          component: DataOverride,
          meta: {
            title: 'Copay ePA Override',
            auth: true,
            groups: ['RxChangeDataViewer'],
            icon: "fa fa-superpowers ",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'Copay ePA Override',
              active: true
            }]
          }
        },
        {
          path: '/prescriber-crosswalk',
          name: 'prescriber-crosswalk',
          component: PrescriberCrosswalk,
          meta: {
            title: 'Prescriber Crosswalk',
            auth: true,
            groups: ['RxChangeDataAdmin'],
            icon: "fa fa-random ",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'Prescriber Crosswalk',
              active: true
            }]
          }
        },
        {
          path: '/denial-code-map',
          name: 'denial-code-map',
          component: DenialCodeMap,
          meta: {
            title: 'Denial/Error Status Mapping',
            auth: true,
            groups: ['RxChangeDataAdmin'],
            icon: "fa fa-map-o",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'Denial/Error Status Mapping',
              active: true
            }]
          }
        },
        {
          path: '/unmapped-denial-code-map',
          name: 'unmapped-denial-code-map',
          component: UnmappedDenialCodeMap,
          meta: {
            title: 'Unmapped Denial/Error Status Mapping',
            auth: true,
            groups: ['RxChangeDataAdmin'],
            icon: "fa fa-map-o",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'Unmapped Denial/Error Status Mapping',
              active: true
            }]
          }
        },
        {
          path: '/copay-epa/source',
          name: 'copay-epa-source-list',
          component: CopayEPASourceList,
          meta: {
            title: 'Copay ePA Sources',
            auth: true,
            groups: ['RxChangeDataApprover', 'RxChangeDataAdmin'],
            icon: "fa fa-ticket",
            isMenuItem: true,
            breadCrumbs: [{
              text: 'Copay ePA Sources',
              active: true
            }]
          }
        }]
    },
    {
      path: '/offer/:copay_offer_id',
      name: 'offer-item',
      component: OfferItem,
      meta: {
        title: 'Offer Item',
        auth: true,
        groups: ['RTPSDataApprover', 'RTPSDataAdmin'],
        isMenuItem: false,
        breadCrumbs: [{
          text: 'Offers',
          active: true
        }]
      }
    },
    {
      path: '/offer/add',
      name: 'offer-add',
      component: OfferItem,
      meta: {
        title: 'Offer Item',
        auth: true,
        groups: ['RTPSDataApprover', 'RTPSDataAdmin'],
        isMenuItem: false,
        breadCrumbs: [{
          text: 'Offers',
          active: true
        }]
      }
    },
    {
      path: '/brand-limit/:brand_limit_id',
      name: 'brand-limit-item',
      component: BrandLimitItem,
      meta: {
        title: 'Brand Limit',
        auth: true,
        groups: ['RTPSDataApprover', 'RTPSDataAdmin'],
        isMenuItem: false,
        breadCrumbs: [{
          text: 'Brand Limit',
          active: true
        }]
      }
    },
    {
      path: '/copay-epa/source/:copay_epa_source',
      name: 'copay-epa-source-item',
      component: CopayEPASourceItem,
      meta: {
        title: 'Copay ePA Source',
        auth: true,
        groups: ['RxChangeDataApprover', 'RxChangeDataAdmin'],
        icon: "fa fa-ticket",
        isMenuItem: false,
        breadCrumbs: [{
          text: 'Copay ePA Source',
          active: true
        }]
      }
    },
    {
      path: '/tokeninfo',
      name: 'tokeninfo',
      component: TokenInfo,
      meta: {
        title: 'Token Info',
        auth: true
      }
    }
  ]
});

router.beforeEach((to, from, next) => {
  // Use the page's router title to name the page
  if (to.meta && to.meta.title) {
    document.title = to.meta.title;
  }

  // Redirect to the login page if not authenticated
  // for pages that have 'auth: true' set
  if (to.meta && to.meta.auth !== undefined) {
    if (to.meta.auth) {
      if (!store.state.auth.isAuthenticated) {
        auth.authenticate();
      } else if (isSessionExpired(store)) {
        store.dispatch('handleSessionExpired', {});
      } else if ((to.meta.groups && _.intersection(to.meta.groups, store.state.auth.groups).length === 0)) {
        gotoDefaultRoute();
      } else {
        next();
      }
    } else {
      next();
    }
  } else {
    gotoDefaultRoute();
  }
});

function isSessionExpired(store) {
  if (store.getters.expiration) {
    return store.getters.expiration < Date.now() / 1000;
  }
  return false;
}

function gotoDefaultRoute() {
  var defaultRoute = _.find(router.options.routes, route =>
    (route.meta.isMenuItem &&
      ((route.meta.groups && _.intersection(route.meta.groups, store.state.auth.groups).length > 0) ||
        !route.meta.groups)));
  if (defaultRoute) {
    router.push(defaultRoute);
  } else if (!store.state.auth.isAuthenticated) {
    auth.authenticate();
  } else if (!store.state.auth.groups || store.state.auth.groups.length === 0) {
    router.push({name: "error", params: {message: "User is not associated with any groups."}});
  } else {
    router.push({name: "error", params: {message: "Could not find default landing page."}});
  }
}

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js